import { configureStore } from '@reduxjs/toolkit';
import participantReducer from '../features/participantSlice';
import spinnerReducer from '../features/spinnerSlice';
import alertReducer from '../features/alertSlice';

export const store = configureStore({
    reducer: {
        participant: participantReducer,
        spinner: spinnerReducer,
        alert: alertReducer,
    },
    // Redux Thunk is included by default
    // Redux DevTools Extension is automatically configured
});